import { downloadFile } from '@/lib/api';
import { useReportingResource } from '@/hooks/useReportingResource';
import NativeWordHistory from './NativeWordHistory';
import CompletionAssessmentForm from './CompletionAssessmentForm';
export const ASSESSMENT_FIELDS=[
 ['management_inquiry','Permintaan keterangan kepada manajemen'],
 ['legal_correspondence','Inspeksi korespondensi hukum'],
 ['board_minutes','Inspeksi risalah rapat'],
 ['legal_confirmation','Konfirmasi penasihat hukum: relevansi, tindakan dan hasil'],
 ['commitments_contingencies','Klaim, komitmen dan kontinjensi yang diidentifikasi'],
 ['accounting_evaluation','Evaluasi perlakuan akuntansi'],
 ['disclosure_evaluation','Evaluasi pengungkapan'],
 ['conclusion','Kesimpulan auditor berdasarkan pekerjaan aktual'],
];
export default function LitigationAssessment({id}) {
 const resource=useReportingResource(id,'litigation-assessment');
 const sources=useReportingResource(id,'evidence');
 if(resource.error)return <div role="alert">{resource.error}</div>;
 if(!resource.data)return <p>Memuat penilaian hukum…</p>;
 return <section><p className="text-xs mb-3">Dokumentasikan prosedur dan bukti aktual, termasuk dasar relevansi konfirmasi hukum. Kesimpulan tanpa perkara tetap memerlukan dukungan dan reviu independen.</p>
 {sources.error&&<p role="alert">{sources.error}</p>}
 <CompletionAssessmentForm key={`${id}:${resource.data.mutation_version||0}`} id={id} data={resource.data}
 fields={ASSESSMENT_FIELDS} title="C120 — Litigasi, Klaim, Komitmen dan Kontinjensi" endpoint={`/engagements/${id}/litigation-assessment`}
 prefix="legal" testId="litigation-assessment" evidence={sources.data||[]} reloadEvidence={sources.reload} reloadAssessment={resource.reload} mutate={resource.mutate} busy={resource.busy}/>
 <button type="button" className="border rounded p-2 text-xs" disabled={!resource.data.id} onClick={()=>downloadFile(`/engagements/${id}/litigation-assessment/export/docx`,'C120-working-copy.docx')}>Ekspor Word C120</button>
 <NativeWordHistory id={id} exportType="C120" recordId={resource.data.id}/>
 </section>;
}
